
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/forgot-email",
      function () {
        return require("private-next-pages/my-account/forgot-email.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/forgot-email"])
      });
    }
  